<!-- Main Style Entry Point -->
<style src="./styles/main.scss" lang="scss"></style>

<template>
  <div id="main">
    <component :is="currentView"></component>
  </div>
</template>

<script>
  import App from './App.vue'
  import Dev from './Dev.vue'
  import config from './data/config'

  const subviews = ['app', 'dev'];

  const vue = {
    data(){
      return {
        currentView: null
      }
    },
    components: {
      App,
      Dev
    },

    ready() {
      $(window).on('hashchange', this.updateCurrentView);
      $(window).on('resize', this.onResize);
      $(window).on('orientationchange', this.onResize);

      $(this.$el).addClass('ready');

      // bootstrap
      this.updateCurrentView();
      _.defer(this.onResize);

      this.flickerAmount = 1.0;
      this.flicker();

      // flicker should fade out - stop after 11 seconds no matter what
      this.flickerTimeout = setTimeout(this.stopFlickering, 11 * 1000);
    },

    beforeDestroy() {
      $(window).off('hashchange', this.updateCurrentView);
      $(window).off('resize', this.onResize);
      $(window).off('orientationchange', this.onResize);

      clearTimeout(this.flickerTimeout);
      this.stopFlickering();
    },

    methods: {

      // throttled resize handler
      onResize: _.throttle(function () {

        const body = document.querySelector('body');
        const el = this.$el;

        if (body && el) {
          const body_rect = body.getBoundingClientRect();
          const el_rect = el.getBoundingClientRect();
          const x = Math.max(Math.round(0.5 * ($(window).width() - el_rect.width)), 0);
          const y = Math.max(Math.round(0.48 * ($(window).height() - el_rect.height)), 0);
          //TweenLite.set(el, { y: y-100});
          //console.log('centering', '#' + el.id, x, y, 'rect: ' + el_rect.width, el_rect.height);
          TweenLite.set(el, {x: x, y: y, alpha: 1.0});
          //TweenLite.to(el, 0.15, {alpha: 1.0, x: x, y: y, ease: 'linear'});

          // don't let things accidently scroll off screen and hide top bar when we can
          $('body').scrollTop(1);
        }

      }, 200),

      // update view on hash change
      updateCurrentView() {
        this.currentView = viewForHash(document.location.hash);
      },

      flicker() {
        if(config.devMode) return;

        var d = (0 - this.flickerAmount);
        this.flickerAmount += .005 * d;
        TweenLite.set('.app-content', {opacity: Math.random() * (.0789 * this.flickerAmount) + .789});

        if (Math.abs(d) > .1) {
          window.requestAnimationFrame(this.flicker);
        } else {
          //console.log('anim stop');
        }
      },

      stopFlickering() {
        //console.log('stop flickering');
        this.flickerAmount = 0;
      }
    }
  };

  // poor man's hash links
  // lookup hash in list of available views - default to the first in the list
  function viewForHash(hash) {
    hash = hash.replace('#', '');
    if (hash.indexOf('/') == 0) hash = hash.substr(1);
    let splat = hash.split('/');
    var idx = subviews.indexOf(splat[0]);
    if (idx < 0) idx = 0;
    return subviews[idx];
  }


  export default vue;

</script>



// WEBPACK FOOTER //
// MainView.vue?2c819621